import { map } from "nanostores"
import { type StatusBarStyle } from "expo-status-bar"

export const $statusBarStyle = map<{
  base: StatusBarStyle
  override: StatusBarStyle | null
}>({ base: "auto", override: null })

export function setStatusBarStyle(style: StatusBarStyle) {
  $statusBarStyle.setKey("base", style)
}

export function setStatusBarOverride(style: StatusBarStyle | null) {
  $statusBarStyle.setKey("override", style)
}
